module.exports = __webpack_public_path__ + "img/gameCheckbox.5662208b.png";